import script from "./ExamResultQuestionBodyMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamResultQuestionBodyMobile.vue?vue&type=script&setup=true&lang=ts"

import "./ExamResultQuestionBodyMobile.vue?vue&type=style&index=0&id=9e1889f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e1889f2"]])

export default __exports__